module.exports = __webpack_public_path__ + "3-43af3267.png";